import React, { useState } from "react";

const ProductVariantCard = ({ product }) => {
    const [expanded, setExpanded] = useState(true);
    const variants = product.variants || [];

    if (variants.length === 0) return null;

    return (
        <div className="card mb-4">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">VARIANTS</h5>
                <button 
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => setExpanded(!expanded)}
                >
                    {expanded ? 'Collapse' : 'Expand'}
                </button>
            </div>
            {expanded && (
                <div className="card-body">
                     <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
                        <table className="table table-hover">
                            <thead className="table-light">
                                <tr>
                                    <th>Sr No.</th>
                                    <th>SKU</th>
                                    <th>Stock</th>
                                    <th> Price</th>
                                 
                                </tr>
                            </thead>
                          <tbody>
    {variants.map((variant, index) => {
        const basePrice = Number(product.price || 0);
        const extraPrice = Number(variant.extra_price || 0);
        const finalPrice = basePrice + extraPrice;

        return (
            <tr key={variant.id || index}>
                <td>{index + 1}</td>

                <td>{variant.sku || "-"}</td>

                <td>{variant.stock || 0}</td>

                <td>
                    ₹{finalPrice.toLocaleString("en-IN")}
                </td>
            </tr>
        );
    })}
</tbody>
                        </table>
                    </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProductVariantCard;